module.exports = __webpack_public_path__ + "img/teams-edit-icon.62dcbcba.svg";